/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberOne(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M131.99574,232a8.00252,8.00252,0,0,1-8.00427-8.00045V46.95129l-35.54531,23.691A8.00167,8.00167,0,1,1,79.56448,57.3298L127.55489,25.344A8.0046,8.0046,0,0,1,140,32.00038V223.99955A8.00252,8.00252,0,0,1,131.99574,232Z" />
    </Svg>
  );
}

export default NumberOne;
